import styled from "@emotion/styled";
import { Button } from "@chakra-ui/react";
import { themeValue } from "../../../utils/themeSelectors";

export const StyledButton = styled(Button)`
  font-weight: 400;
  font-size: ${themeValue('fontSizes')('sm')};
`;